import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {Partner} from '../../../shared/interface/partner';
import {MatDialog} from '@angular/material/dialog';
import {FacilityAddDialogComponent} from '../facility-add-dialog/facility-add-dialog.component';
import {PartnerService} from '../../../shared/services/partner.service';
import {PartnerFacility} from '../../../shared/interface/partner-facility';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {FacilityService} from '../../../shared/services/facility.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Observable, ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {takeUntil} from 'rxjs/operators';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-facilities-list',
  templateUrl: './facilities-list.component.html',
  styleUrls: ['./facilities-list.component.scss']
})
export class FacilitiesListComponent implements AfterViewInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() partner: Observable<Partner>;
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = ['street', 'houseNumber', 'apartmentNumber', 'city', 'zipCode', 'state', 'activeOfwcas', 'actions'];
  userPermissions: ReplaySubject<UserPermissions>;
  partnerObject: Partner;

  dataSource: MatTableDataSource<PartnerFacility> = new MatTableDataSource<PartnerFacility>([]);

  constructor(
    public dialog: MatDialog,
    private partnerService: PartnerService,
    private facilityService: FacilityService,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.partner
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((partner: Partner) => {
        this.partnerObject = partner;
        this.loadFacilities();
    });
  }

  loadFacilities(): void {
    this.partnerService.getPartnerFacilities(this.partnerObject.uuid)
      .subscribe((response: ListResponse<PartnerFacility>) => {
        this.dataSource.data = response.items;
      });
  }

  addFacility(): void {
    const dialogRef = this.dialog.open(FacilityAddDialogComponent, {
      width: '600px',
      data: {partner: this.partnerObject},
      height: '90%',
      maxHeight: '2000px',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadFacilities();
    });
  }

  deleteFacility(facility: PartnerFacility): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć placówkę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.facilityService.deleteFacility(facility.address.uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto placówkę', '', {duration: 2000});
              this.loadFacilities();
              this.changed.emit(true);
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 2000});
            }
          });
      }
    });
  }
}
